"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterStyledSystemPaddingProps;

var _filterObjectProperties = _interopRequireDefault(require("../../utils/helpers/filter-object-properties"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const paddingPropertyNames = ["padding", "p", "paddingLeft", "pl", "paddingRight", "pr", "paddingTop", "pt", "paddingBottom", "pb", "paddingX", "px", "paddingY", "py"];

function filterStyledSystemPaddingProps(originalObject) {
  return (0, _filterObjectProperties.default)(originalObject, paddingPropertyNames);
}